/* Isolated display control: no cart, pricing, or checkout changes. */
if (!customElements.get('cc-announcement-ticker')) {
  customElements.define('cc-announcement-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
    }
  });
}
